"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var State = /** @class */ (function () {
    function State(value, history, actions) {
        if (actions === void 0) { actions = []; }
        this.value = value;
        this.history = history;
        this.actions = actions;
    }
    State.from = function (stateValue) {
        if (stateValue instanceof State) {
            return stateValue;
        }
        return new State(utils_1.toTrie(stateValue));
    };
    State.inert = function (stateValue) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) {
                return stateValue;
            }
            return new State(stateValue.value, stateValue.history, []);
        }
        return State.from(stateValue);
    };
    State.prototype.toString = function () {
        if (typeof this.value === 'string') {
            return this.value;
        }
        var path = [];
        var marker = this.value;
        while (true) {
            if (typeof marker === 'string') {
                path.push(marker);
                break;
            }
            var _a = Object.keys(marker), firstKey = _a[0], otherKeys = _a.slice(1);
            if (otherKeys.length) {
                return undefined;
            }
            path.push(firstKey);
            marker = marker[firstKey];
        }
        return path.join(constants_1.STATE_DELIMITER);
    };
    return State;
}());
exports.State = State;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/State.js
// module id = 711
// module chunks = 168707334958949